import Cookies from "js-cookie" // debug cookies

import constants from "../consts/config"

export default function checkEnabled() {
  if (typeof window === "undefined") {
    return false
  }

  const enabled =
    !window.location.href.includes("enable_magic=off") &&
    (window.location.href.includes("enable_magic") ||
      window.location.hostname.includes(constants.stagingEnvironmentUrl) ||
      Cookies.get("enable_magic") ||
      window.SP_GLOBALS.SKYPICKER_ENV !== "production")

  if (enabled) {
    Cookies.set("enable_magic", "full_magic")
  }
  return enabled
}
